import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Stack,
  Typography,
} from '@mui/material';
import { DateCalendar } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import { Dispatch, FC, SetStateAction, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { ErrorIcon } from '../../../../vectors/index';
import { authContext } from '@staffedupusa/shared-components';

type NotEnoughSlotsModalProps = {
  isOpen: boolean;
  handleClose: () => void;
};

const NotEnoughSlotsModal: FC<NotEnoughSlotsModalProps> = ({
  isOpen,
  handleClose,
}) => {
  const { authData } = useContext(authContext);
  const navigate = useNavigate();

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <br />
        <ErrorIcon />
        <br />
        <Typography variant="h4" sx={{ p: 3 }}>
          Not Enough Slots
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3}>
          <Alert severity="warning">
            Oops! It looks like you don't have enough available interview slots! for this company or job.
            You can create new interview blocks from your Calendar.
          </Alert>

          <Button
            variant="contained"
            color="secondary"
            startIcon={<CalendarMonthIcon />}
            onClick={() => navigate(authData?.user?.company ? '/employer/calendar/' : authData?.user?.enterprise ? '/enterprise/calendar/' : '')}
          >
            Go to Calendar
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default NotEnoughSlotsModal;
